// Web Audio API feedback beeps
let ctx = null;
const getCtx = () => {
  if (!ctx) {
    const AC = window.AudioContext || window.webkitAudioContext;
    if (AC) ctx = new AC();
  }
  if (ctx && ctx.state === "suspended") ctx.resume();
  return ctx;
};

const tone = (freq, duration, type = "sine", gainVal = 0.15) => {
  const c = getCtx();
  if (!c) return;
  const osc = c.createOscillator();
  const gain = c.createGain();
  osc.type = type;
  osc.frequency.value = freq;
  gain.gain.setValueAtTime(gainVal, c.currentTime);
  gain.gain.exponentialRampToValueAtTime(0.0001, c.currentTime + duration);
  osc.connect(gain);
  gain.connect(c.destination);
  osc.start();
  osc.stop(c.currentTime + duration);
};

export const beepCarico = () => {
  tone(660, 0.1, "sine", 0.2);
  setTimeout(() => tone(1046, 0.13, "sine", 0.18), 85); // ascendente = carico
};

export const beepScarico = () => {
  tone(1046, 0.1, "sine", 0.2);
  setTimeout(() => tone(660, 0.15, "sine", 0.18), 85); // discendente = scarico
};

export const beepError = () => {
  tone(220, 0.35, "sawtooth", 0.18);
};

// Sblocca/riprende il contesto audio su gesto utente (necessario su mobile)
export const unlockAudio = () => { getCtx(); };
